import api_comm from "./lib";

async function downloads(file) {
	return api_comm("get", "/site/api/v2/page/" + file);
}

export default downloads;
